if (!customElements.get('features-slider')) {
	customElements.define('features-slider', class FeaturesSlider extends HTMLElement {
			constructor() {
				super();
			}

			connectedCallback() {
				this.carousel = this.querySelector('.media-icon-items-grid');
				this.initialize();
			}

			initialize() {
				const autoplayEnabled = this.getAttribute('data-autoplay') === 'true';
				this.flickity = new Flickity(this.carousel, {
					autoPlay: autoplayEnabled ? 3500 : false,
					cellAlign: 'center',
					groupCells: false,
					contain: true,
					resize: true,
					draggable: true,
					prevNextButtons: false,
					cellSelector: '.media-icon-item',
					initialIndex: 0,
					pageDots: false,
					wrapAround: true,
					accessibility: false,
					watchCSS: true,
				});
			}
		}
	);
}

if (!customElements.get('features-slider-navigation')) {
	customElements.define('features-slider-navigation', class FeaturesSliderNavigation extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.init();
		}

		init(retry = 1, maxRetry = 3) {
			if (retry === maxRetry) {
				return;
			}

			const id = this.getAttribute('for');
			this.carouselComponent = document.querySelector(`#${id}`);

			if ((!this.carouselComponent || !this.carouselComponent.flickity)) {
				setTimeout(() => {
					this.init(retry + 1);
				}, 350);
				return;
			}

			this.flickity = this.carouselComponent.flickity;
			this.buttonPrev = this.querySelector('.js-prev');
			this.buttonNext = this.querySelector('.js-next');

			this.buttonPrev.addEventListener('click', (event) => {
				event.preventDefault();
				this.flickity.previous();
			});

			this.buttonNext.addEventListener('click', (event) => {
				event.preventDefault();
				this.flickity.next();
			});
		}
	});
}
